import { render, staticRenderFns } from "./UpSellNew.vue?vue&type=template&id=2c1b6f60&"
import script from "./UpSellNew.vue?vue&type=script&lang=js&"
export * from "./UpSellNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports